import {api} from '../../../utils/api'

const homeApi = api.injectEndpoints({
    endpoints: (builder) => ({
        inclusiveHiringEmployers: builder.query({
            query: () => `/exampleprovider/inclusive-hiring-employers-directory/`,
        }),
    }),
});

export const {useInclusiveHiringEmployersQuery} = homeApi;